// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"881":"1b5604dec1618764","2888":"7e8ba09192ffc6f0"}[chunkId] + ".css";
};